import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import { withTransientProps } from "core/utils/transientProps";

export function KpiLayout(props) {
  const { children, title, loading, Icon, onClickEvent, cursorEnable } = props;

  return (
    <KpiCard $cursorEnable={cursorEnable} onClick={onClickEvent}>
      {loading ? (
        <KpiSkeleton />
      ) : (
        <>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <KpiTitle>{title}</KpiTitle>
            <Grid item>{children}</Grid>
            <KpiIcon item>
              <Icon fontSize="inherit" />
            </KpiIcon>
          </Grid>
          <KpiDivider />
        </>
      )}
    </KpiCard>
  );
}

const KpiTitle = styled("div")`
  color: #777;
  font-size: 14px;
  width: 100%;
`;

const KpiCard = styled(Card, withTransientProps)`
  padding: 16px;
  margin-top: 0;
  height: 119px;
  background: #ffffff;
  boxshadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  cursor: ${({ $cursorEnable }) => ($cursorEnable ? "pointer" : "default")};
`;

const KpiSkeleton = styled(Skeleton)`
  min-height: 100%;
`;

const KpiIcon = styled(Grid)`
  text-align: right;
  color: #777;
  font-size: 3rem;
`;

const KpiDivider = styled("div")`
  border: 1px solid #c4c4c4;
  margin-top: 3px;
`;

KpiLayout.propTypes = {
  loading: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
  Icon: PropTypes.object,
  onClickEvent: PropTypes.func,
  cursorEnable: PropTypes.bool
};
